/*
 * A button with a list under it. The list is absolute so opening the menu never
 * reflows the header it sits in.
 */
.menu {
  position: relative;

  display: inline-flex;
}

.list {
  position: absolute;
  inset-block-start: calc(100% + var(--space-2xs));
  inset-inline-end: 0;
  z-index: 20;

  display: flex;
  flex-direction: column;

  min-width: 12rem;
  padding: var(--space-2xs);

  background-color: var(--surface-raised);

  border: 1px solid var(--border-strong);
  border-radius: var(--radius-s);
  box-shadow: var(--shadow-raised);
}

.item {
  padding: var(--space-xs) var(--space-s);

  font-size: var(--size-200);
  text-align: start;

  color: var(--text);
  background-color: transparent;

  border: 0;
  border-radius: var(--radius-s);

  cursor: pointer;
}

.item:hover:not(:disabled) {
  color: var(--accent-strong);
  background-color: rgb(255 255 255 / 6%);
}

.item:disabled {
  color: var(--text-faint);

  cursor: not-allowed;
}
